import React from 'react';


type RadioInputProps = {
  question: React.ReactNode; 
  options: { value: string; displayedName: string }[];
  value: string;
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const RadioInput: React.FC<RadioInputProps> = ({ question, options, value, name, onChange}) => {
    
    return (
        <fieldset>
          {/* The question prop can be anything React can render */}
          <legend className="text-gray-800 text-lg font-light">{question}</legend>
          <div
            className="mx-auto w-fit grid mt-4 "
            style={{ gridTemplateColumns: "1fr 1fr" }} // Two columns
          >
            {options.map((option, optionIndex) => (
              <label
                key={optionIndex}
                className="w-fit text-gray-900 text-lg mb-4"
                style={{
                  display: "",
                  alignItems: "center",
                  wordWrap: "break-word",
                  gridColumn: option.displayedName.length > 40 ? "span 2" : "auto", // Span both columns for long options
                }}
              >
                <input
                  className="mx-2"
                  type="radio"
                  name={name}
                  value={option.value}
                  checked={value === option.value}
                  onChange={onChange}
                />
                {option.displayedName}
              </label>
            ))}
          </div>
        </fieldset>
      );
    };

export default RadioInput;